import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Case } from "./case";

export class CaseNotificationNumber extends Resource {
    public override type = 'caseNotificationNumbers';

    @prop()
    @required()
    public caseId!: string;

    public case!: Case;

    @prop()
    public date!: Date;

    @prop()
    public code!: string;

    @prop()
    public description?: string;

    @prop()
    public capabilityDescription?: string;

    @prop()
    public displayInfo?:string;

    @prop()
    public reviewDate?: Date;

    @prop()
    public state?: string;

}
